export default function trimItems <T extends Record<string, any>>(obj: T): T {
  return Object.entries(obj).reduce((acc, [key, value]) => ({
    ...acc,
    [key]: typeof value === 'string'
      ? value.trim()
      : value
  }), {} as T)
}